import { escapeHtml } from '@/utils/escape';
import { html } from '@/utils/html';

const LandingConfirmationModal = config => {
    const { title = null, message = null, confirmText = null, cancelText = null } = config;
    let modalElement = null;
    let onConfirm = null;
    let onCancel = null;

    const createModal = () => {
        return $(html`
            <div id="landingConfirmationModal" class="fixed inset-0 z-[100] hidden items-center justify-center bg-black/50 p-4 backdrop-blur-[2px]">
                <div
                    class="relative w-full max-w-2xl rounded-3xl border border-orange-100 bg-white p-6 shadow-xl md:p-8"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="landingConfirmationModalTitle"
                >
                    <button
                        type="button"
                        id="landingConfirmationModalClose"
                        class="absolute right-4 top-4 rounded-full p-1 text-gray-400 transition hover:bg-orange-50 hover:text-orange-500"
                        aria-label="閉じる"
                    >
                        <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>
                    <div class="mb-6 flex items-start gap-4 pr-8">
                        <div class="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-orange-100">
                            <svg class="h-6 w-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
                                ></path>
                            </svg>
                        </div>
                        <div id="landingConfirmationModalTitleMessage">
                            <h3 id="landingConfirmationModalTitle" class="text-xl font-bold text-gray-900">${escapeHtml(title || '登録確認')}</h3>
                            <p id="landingConfirmationModalMessage" class="mt-1 text-base leading-relaxed text-gray-600">${escapeHtml(message || '以下の内容で登録してよろしいですか？')}</p>
                        </div>
                    </div>

                    <div id="landingConfirmationDataContainer" class="mb-6 max-h-60 overflow-y-auto rounded-2xl border border-orange-100 bg-[#fffdf5] p-4 lg:max-h-[60vh]">
                        <div id="landingConfirmationData" class="space-y-2 text-sm">
                            <!-- populated dynamically -->
                        </div>
                    </div>

                    <div class="flex flex-wrap items-center justify-between gap-3">
                        <button
                            type="button"
                            id="landingConfirmationCancel"
                            class="rounded-full border border-orange-200 bg-white px-5 py-2.5 text-sm font-bold text-gray-700 transition hover:border-orange-300 hover:bg-orange-50"
                        >
                            ${escapeHtml(cancelText || 'キャンセル')}
                        </button>
                        <button type="button" id="landingConfirmationConfirm" class="rounded-full bg-orange-500 px-5 py-2.5 text-sm font-bold text-white shadow-sm transition hover:bg-orange-600">
                            ${escapeHtml(confirmText || '登録する')}
                        </button>
                    </div>
                </div>
            </div>
        `);
    };

    const show = (confirmCallback, cancelCallback, dataToShow = null) => {
        onConfirm = confirmCallback;
        onCancel = cancelCallback;

        if (!modalElement) {
            modalElement = createModal();
            $('body').append(modalElement);
            bindEvents();
        }

        const dataContainer = modalElement.find('#landingConfirmationDataContainer');
        if (dataToShow && dataToShow.length) {
            dataContainer.removeClass('hidden');
            populateData(dataToShow);
        } else {
            dataContainer.addClass('hidden');
        }

        modalElement.removeClass('hidden').addClass('flex');
        document.body.style.overflow = 'hidden';
    };

    const hide = () => {
        if (modalElement) {
            modalElement.addClass('hidden').removeClass('flex');
            document.body.style.overflow = '';
        }
    };

    const setTitle = nextTitle => {
        modalElement.find('#landingConfirmationModalTitleMessage').find('h3').text(nextTitle);
    };

    const setMessage = nextMessage => {
        modalElement.find('#landingConfirmationModalMessage').text(nextMessage);
    };

    const setConfirmText = text => {
        modalElement.find('#landingConfirmationConfirm').text(text);
    };

    const setCancelText = text => {
        modalElement.find('#landingConfirmationCancel').text(text);
    };

    const populateData = dataToShow => {
        const confirmationData = modalElement.find('#landingConfirmationData');
        confirmationData.empty();

        dataToShow.forEach(item => {
            const div = $('<div class="flex border-b border-orange-100/80 py-2 last:border-0 last:pb-0"></div>');
            div.append(
                $('<span class="w-2/5 shrink-0 text-right text-sm font-bold text-orange-600 md:w-1/3"></span>').text(item?.label ?? ''),
                $('<span class="mx-2 shrink-0 text-sm text-gray-400">:</span>'),
                $('<span class="min-w-0 flex-1 break-all whitespace-pre-wrap text-sm text-gray-800"></span>').text(item?.value ?? '')
            );
            confirmationData.append(div);
        });
    };

    const bindEvents = () => {
        modalElement.on('click', '#landingConfirmationModalClose', () => {
            hide();
            if (onCancel) {
                onCancel();
            }
        });

        modalElement.on('click', '#landingConfirmationConfirm', () => {
            hide();
            if (onConfirm) {
                onConfirm();
            }
        });

        modalElement.on('click', '#landingConfirmationCancel', () => {
            hide();
            if (onCancel) {
                onCancel();
            }
        });

        modalElement.on('click', e => {
            if (e.target === modalElement[0]) {
                hide();
                if (onCancel) {
                    onCancel();
                }
            }
        });

        $(document).on('keydown.landingConfirmationModal', e => {
            if (e.key === 'Escape' && !modalElement.hasClass('hidden')) {
                hide();
                if (onCancel) {
                    onCancel();
                }
            }
        });
    };

    const destroy = () => {
        if (modalElement) {
            modalElement.remove();
            modalElement = null;
        }
        $(document).off('keydown.landingConfirmationModal');
    };

    return {
        show,
        hide,
        destroy,
        setTitle,
        setMessage,
        setConfirmText,
        setCancelText
    };
};

export default LandingConfirmationModal;
